<template>
  <div class="app">
    <header class="header bg--primary">
      <h1 class="header__title txt--white mt--1 mb--1 ml--1 mr--1 ml--1">{{ pathwayName }}</h1>
      <div class="header__cta mt--1 mb--1 mr--1 show--md">
        <q-button-icon
          @click="compressSvg"
          v-if="!svgState"
          icon="undo-alt"
          addClass="mr--1"
          title="View Pathway as whole"
        />
        <q-button-icon
          @click="expandSvg"
          v-if="svgState"
          icon="undo-alt"
          addClass="mr--1"
          title="Zoom Pathway at 100%"
        />
        <q-button-icon @click="displayKeys" v-if="showKeyButton=='True'" icon="key" addClass="mr--1" title="View Keys" />
        <q-button-icon @click="editPathwayMetadata" icon="cog" title="Pathway Information" />
      </div>
    </header>

    <!-- <nav class="breadcrumb bg--tertiary pl--1 pr--1 hide">
      <a
        href="#"
        class="txt--xs txt--decoration txt--upper txt--secondary txt--strong mr--1 d--ib"
      >Parent Page</a>
      <a
        href="#"
        class="txt--xs txt--decoration txt--upper txt--secondary txt--strong mr--1 d--ib"
      >Parent Page</a>
      <a
        href="#"
        class="txt--xs txt--decoration txt--upper txt--secondary txt--strong mr--1 d--ib"
      >Current Page</a>
    </nav> -->

    <div class="header__mob pt--1 pb--1 pr--1 pl--1 hide--md">
      <q-button-icon
        @click="compressSvg"
        v-if="!svgState"
        icon="undo-alt"
        addClass="mr--1"
        title="View Pathway as whole"
      />
      <q-button-icon
        @click="expandSvg"
        v-if="svgState"
        icon="undo-alt"
        addClass="mr--1"
        title="Zoom Pathway at 100%"
      />
      <q-button-icon @click="displayKeys" v-if="showKeyButton=='True'" icon="key" addClass="mr--1" title="View Keys" />
      <q-button-icon @click="editPathwayMetadata" icon="cog" title="Pathway Information" />
    </div>

    <div class="canvas" id="canvas-container">
      <svg id="svg" class="svg-canvas" xmlns="http://www.w3.org/2000/svg" style="display: inline; width: inherit; min-width: inherit; max-width: inherit; height: inherit; min-height: inherit; max-height: inherit;" version="1.1"></svg>
    </div>
    <MetadataPanel title="Edit Metadata" />
    <ViewKeys v-bind:display="showKeys" />
  </div>
</template>

<script>
/**
 * Import Components and Editor
 */
import { editor } from "../js/editor.js";
import MetadataPanel from "@/components/MetadataPanel.vue";
import ViewKeys from "@/components/ViewKeys.vue";
import * as d3 from "d3-selection";
import {externalfuncs} from "../js/external.js";
import svgPanZoom from "svg-pan-zoom/src/svg-pan-zoom.js";
import * as Hammer from 'hammerjs';

/**
 * Export Component "SetupCanvas"
 * @props msg : String
 */
export default {
  mixins: [editor],
  name: "Start",
  components: {
    MetadataPanel,
    ViewKeys
  },
  props: {
    msg: String,
    sk: Boolean
  },
  data() {
    return {
      isActive: false,
      showKeys: false,
      showDelete: false,
      svgState: false,
      pathwayName: "",
      currentState: 1,
      editingNode: 0,
      showKeyButton: false
    };
  },
  mounted() {

    var self = this;
    this.s = Snap("#svg");
    this.svg = d3.select("#svg");
		this.renderchart();

    this.showKeyButton = document.getElementById("showKeyButton").value;

    /**
     * Render SVG Snap Chart
     */
    this.$root.$on("forceRenderChart", () => {
			self.renderchart();			
    });

    /**
     * Expand
     */
    this.$root.$on("expandSvg", () => {
     
      this.togglezoom();
      
      // self.svgState = false;
      // var svgCanvas = document.getElementById("svg");
      // svgCanvas.removeAttribute("style");
      // svgCanvas.classList.remove("svg--check");
      //self.scrollIntoCenter();
    });

    /**
     * Compress
     */
    this.$root.$on("compressSvg", () => {
      this.togglezoom();

      //this.zm.resetZoom();
      //this.zm.reset();
      //this.zm.zoom(2);
      //this.zm.center();
      //this.zm.getZoom();
      // self.svgState = true;
      // self.checkSizeOfSvg();
      // var svgCanvas = document.getElementById("svg");
			// svgCanvas.classList.add("svg--check");
    });

    /**
     * Close Panel
     */
    this.$root.$on("closePanel", () => {
      self.isActive = false;
      self.editingNode = 0;
      this.$root.$emit("removeActiveNode");
    });

    /**
     * Close Dialog box
     */
    this.$root.$on("closeDialog", () => {
      self.showKeys = false;
    });

    /**
     * Remove Active Class Node
     */
    this.$root.$on("removeActiveNode", () => {
      this.svg.selectAll(".node__box").classed("node__box--active", false);
    });

    /**
     * Extending Edit Node Function
     * @param el : This current element
     */
    this.$root.$on("editNode", el => {
      self.isActive = true;
      self.editingNode = el.id;
    });

    this.$root.$on("linkclickevent", (e) => { 
      externalfuncs.nativeCallback(e);
    });



    //this.zm = window.canvasPathwy;
    setTimeout(() => {
    var eventsHandler;
    eventsHandler = {
      haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel']
			, init: function(options) {
					var instance = options.instance
						, initialScale = 1
						, pannedX = 0
						, pannedY = 0

					// Init Hammer
					// Listen only for pointer and touch events
					this.hammer = Hammer(options.svgElement, {
						inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
					})

					// Enable pinch
					this.hammer.get('pinch').set({enable: true})

					// Handle double tap
					this.hammer.on('doubletap', function(){
						instance.zoomIn();
					})

					// Handle pan
					this.hammer.on('panstart panmove', function(ev){
						// On pan start reset panned variables
						if (ev.type === 'panstart') {
							pannedX = 0;
							pannedY = 0;
						}

						// Pan only the difference
						instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY});
						this.pan = {x: ev.deltaX - pannedX, y: ev.deltaY - pannedY};
						pannedX = ev.deltaX;
						pannedY = ev.deltaY;
					})

					// Handle pinch
					this.hammer.on('pinchstart pinchmove', function(ev){
						// On pinch start remember initial zoom
						if (ev.type === 'pinchstart') {
							initialScale = instance.getZoom();
							instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y});
						}

						instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y});
						this.zoom = initialScale * ev.scale;
						this.pan = {x: ev.center.x, y: ev.center.y};
					})

					// Prevent moving the page on some devices when panning over SVG
					options.svgElement.addEventListener('touchmove', function(e){ e.preventDefault(); });
				}

			, destroy: function(){
					this.hammer.destroy();
				}
		}

		this.zm = svgPanZoom('#svg', {
			zoomEnabled: true,
			controlIconsEnabled: false,
			fit: true,
			center: true,
			customEventsHandler: eventsHandler,
		});

		this.zm.resize();
		this.zm.fit();
		this.zm.center();
		this.zm.zoom(0.9);
    }, 1000);
  },
  methods: {
    togglezoom(){
      
        this.zm.resize();
        this.zm.fit();
        this.zm.center();
				this.zm.zoom(0.9);

      // if(this.pan!=null)
      // {
      //   this.zm.pan({x: this.pan.x, y: this.pan.y});
      //   this.zm.zoom(this.zoom);
      //   this.pan = null;
      // }
      // else
      // {

      //   this.pan = this.zm.getPan();
      //   this.zoom = this.zm.getZoom();
      //   this.zm.resize();
      //   this.zm.fit();
      //   this.zm.center();
        
      // }
    },

    /**
     * Edit Pathway Dialog Method
     * Parsing pathwayName
     */
    editPathwayMetadata() {
      this.isActive = true;
      this.$root.$emit("editPathway", this.pathwayName);
    },
    /**
     * Show Pathway Dialog Keys
     * Parsing pathwayName
     */
    displayKeys() {
      this.showKeys = true;
    },

    /**
     * Show Pathway Dialog Keys
     */
    compressSvg() {
      this.$root.$emit("compressSvg");
    },

    /**
     * Show Pathway Dialog Keys
     */
    expandSvg() {
      this.$root.$emit("expandSvg");
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/modules/canvas.scss";
</style>
